import { useEffect, useState } from "react";
import { G } from "../constants/theme";
import { TEAM } from "../constants/team";
import Label from "../components/ui/Label";
import BigTitle from "../components/ui/BigTitle";
import BodyText from "../components/ui/BodyText";
import { Wrap, Sec } from "../components/ui/Layout";
import PageHero from "../components/ui/PageHero";
import TeamCard from "../components/ui/TeamCard";

export default function About() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return (
    <>
      <PageHero
        label="Company"
        title={
          <>
            ABOUT MIDDLE EAST
            <br />
            BLACK CARBON
          </>
        }
        sub="Supplying recovered carbon black materials derived from tire pyrolysis operations for industrial use worldwide."
      />

      {/* Operations & philosophy */}
      <Sec bg={G.black}>
        <Wrap>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: 56,
            }}
          >
            <div>
              <Label>Operations</Label>
              <h3
                style={{
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: 30,
                  color: G.white,
                  letterSpacing: 1,
                  marginBottom: 14,
                }}
              >
                PRODUCTION &amp; COORDINATION
              </h3>
              <p style={{ fontSize: 14, color: G.muted, lineHeight: 1.8 }}>
                Our production facility is located in Syria. Commercial communication, international
                coordination, and buyer communication are handled from Canada.
                <br />
                <br />
                This structure allows direct access to production while providing professional
                international communication for buyers and partners globally.
              </p>
            </div>

            <div>
              <Label>Philosophy</Label>
              <h3
                style={{
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: 30,
                  color: G.white,
                  letterSpacing: 1,
                  marginBottom: 14,
                }}
              >
                OUR APPROACH
              </h3>
              <p style={{ fontSize: 14, color: G.muted, lineHeight: 1.8 }}>
                We are focused on transparent product representation, technical data sharing, sample
                evaluation, and building long-term relationships with industrial buyers.
                <br />
                <br />
                We present our material based on available laboratory data and encourage buyers to
                evaluate it against their own application requirements.
              </p>
            </div>
          </div>
        </Wrap>
      </Sec>

      {/* Team */}
      <Sec bg={G.deep}>
        <Wrap>
          <Label>Leadership</Label>
          <BigTitle>OUR TEAM</BigTitle>
          <BodyText>
            The founding and management team brings combined decades of experience in industrial
            operations, materials recycling, and international commercial coordination.
          </BodyText>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "repeat(3,1fr)",
              gap: 1,
              background: G.border,
              border: `1px solid ${G.border}`,
            }}
          >
            {TEAM.map((member) => (
              <TeamCard key={member.name} m={member} />
            ))}
          </div>
        </Wrap>
      </Sec>
    </>
  );
}
